import { SortDescriptor } from "react-aria-components";

import { WebhookDelivery } from "types/generated";

import { WEBHOOK_DELIVERIES_COLUMN_ID } from "./constants";

export const sortWebhookDeliveries = (
  deliveries: WebhookDelivery[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column || !sortDescriptor.direction) {
    return deliveries;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...deliveries].sort((a, b) => {
    switch (sortDescriptor.column as WEBHOOK_DELIVERIES_COLUMN_ID) {
      case WEBHOOK_DELIVERIES_COLUMN_ID.ID:
        return isAscending
          ? a.id.localeCompare(b.id, undefined, { numeric: true })
          : b.id.localeCompare(a.id, undefined, { numeric: true });
      case WEBHOOK_DELIVERIES_COLUMN_ID.STATUS:
        return isAscending ? a.status - b.status : b.status - a.status;
      case WEBHOOK_DELIVERIES_COLUMN_ID.TIMESTAMP:
        return isAscending ? a.timestamp - b.timestamp : b.timestamp - a.timestamp;

      case WEBHOOK_DELIVERIES_COLUMN_ID.DROPDOWN:
      default:
        return 0;
    }
  });
};
